export type ProductListItem = {
    id: number;
    code: string | null;
    supplier_code?: string | null;
    name: string;
    image_url: string | null;
    group_name: string | null;
    product_type: string | null;
    product_type_label: string | null;
    product_type_color: string | null;
    category: string | null;
    series: string | null;
    unit_price: number | null;
    stock_quantity: number;
    stock_cd?: number;
    stock_reserved?: number;
    stock_transit?: number;
    colors?: string[];
    color_swatches?: {
        parts: { part: 'frame' | 'seat' | 'stitches' | 'arm'; colors: { name: string; hex: string | null }[] }[];
        total: number;
    };
    color_options?: Record<string, string[] | undefined> | null;
    suspended?: boolean;
};

export type ProductCatalogStats = {
    total: number;
    in_stock: number;
    out_of_stock: number;
    in_transit: number;
    by_category: Record<string, number>;
};

export type ProductFilterOptions = {
    groups: string[];
    types: string[];
    categories: string[];
    series: string[];
    stats?: ProductCatalogStats;
};

export type ProductCatalogFilter =
    | { type: 'all' }
    | { type: 'in_stock' }
    | { type: 'out_of_stock' }
    | { type: 'in_transit' }
    | { type: 'category'; value: string }
    | { type: 'group'; value: string }
    | { type: 'type'; value: string }
    | { type: 'series'; value: string };

export type ProductListMeta = {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
};

export type ProductListResponse = {
    data: ProductListItem[];
    meta: ProductListMeta;
};

export type SortMode = 'name' | 'code' | 'unit_price' | 'stock_quantity';
export type ViewMode = 'grid' | 'list';

export const DEFAULT_PRODUCT_FILTER: ProductCatalogFilter = {
    type: 'type',
    value: 'equipamento',
};
